<template>
  <div id="Heating">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.water.title") }}</div>
      <div class="container inline top">
        <EnergyButton 
          @click="water = 'elec'"
          :active="water === 'elec'"
          :title="$t('elec')"
          type="elec"
        />
        <EnergyButton 
          @click="water = 'gas'"
          :active="water === 'gas'"
          :title="$t('gas')"
          type="gas"
        />
        <EnergyButton 
          @click="water = 'other'"
          :active="water === 'other'"
          :title="$t('other')"
          type="other"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EnergyButton from "@/components/Energy/EnergyButton.vue";

export default {
  computed: {
    ...mapState("energy", ["type"]),
    water: {
      get() {
        return this.$store.state.consumption.water;
      },
      set(value) {
        this.$store.commit("consumption/setWater", value);
      }
    }
  },
  created() {
    if (!this.water) {
      if (this.type === "elec") this.water = "elec";
      else this.water = "gas";
    }
  },
  components: {
    EnergyButton
  }
};
</script>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/WaterType.vue